import React from 'react';
import axios from 'axios';

function ProductTypeLabelCase(productType) {
  switch(productType) {
    case "domain": {
      return "Tên miền"
    }
    case "vps" : {
      return "VPS"
    }
    case "hosting" : {
      return "Hosting"
    }
    case "ssl" : {
      return "SSL"
    }
    case "email" : {
      return "Email Server"
    }
    case "tadu_phone" : {
      return "Tổng Đài Ảo"
    }
    case "tadu_invoice" : {
      return "Hoá Đơn Điện Tử"
    }
    case "cloud_backup" : {
        return "Cloud Backup"
    }
    case "whois" : {
      return "Who Is Privacy"
    }
    case "IP" : {
      return "IP"
    }
    default: {
      return "Tất cả dịch vụ"
    }
  }
}

class LabelButton extends React.Component {
  render() {
    const { onProductSelect, domainStatic, vpsStatic, hostingStatic, emailStatic, sslStatic, taduPhoneStatic, taduInvoiceStatic, cloudBackupStatic} = this.props;
    const styles = {
      color: "white",
      marginRight: 3,
      borderColor: 'transparent',
      borderRadius: "3px"
    }
    return (
      <React.Fragment>
        <button style={styles} onClick={() => onProductSelect("all")} className="badge bg-indigo"><i className="icon-three-bars"></i> Tất cả dịch vụ</button>
        <button style={styles} onClick={() => onProductSelect("domain")} className="badge badge-info"><i className="icon-earth"></i> Tên miền: {domainStatic}</button>
        <button style={styles} onClick={() => onProductSelect("hosting")} className="badge badge-success"><i className="icon-server"></i> Hosting: {hostingStatic}</button>
        <button style={styles} onClick={() => onProductSelect("ssl")} className="badge badge-warning"><i className="icon-shield-check"></i>SSL: {sslStatic}</button>
        <button style={styles} onClick={() => onProductSelect("vps")} className="badge badge-secondary"><i className="icon-cloud"></i> VPS: {vpsStatic}</button>
        <button style={styles} onClick={() => onProductSelect("email")} className="badge badge-primary"><i className="icon-mail-read"></i> Email Server: {emailStatic}</button>
        <button style={styles} onClick={() => onProductSelect("tadu_phone")} className="badge bg-purple"><i className="icon-phone2"></i> Tổng Đài Ảo: {taduPhoneStatic}</button>
        <button style={styles} onClick={() => onProductSelect("tadu_invoice")} className="badge bg-brown"><i className="icon-calculator"></i> Hoá Đơn Điện Tử: {taduInvoiceStatic}</button>
        <button style={styles} onClick={() => onProductSelect("cloud_backup")} className="badge bg-teal"><i className="icon-cloud-upload"></i> Cloud Backup: {cloudBackupStatic}</button>
      </React.Fragment>
    )
  }
}

function DropboxButton(onProductSelect, product_type_selected) {
    return (
      <React.Fragment>
        <div className="btn-group">
          <button type="button" className="btn btn-primary dropdown-toggle" data-toggle="dropdown" aria-expanded="false">
            {ProductTypeLabelCase(product_type_selected)}
          </button>
          <div className="dropdown-menu" x-placement="bottom-start">
            <a onClick={() => onProductSelect("all")} className="dropdown-item">Tất cả dịch vụ</a>
            <a onClick={() => onProductSelect("domain")} className="dropdown-item">Tên miền</a>
            <a onClick={() => onProductSelect("hosting")} className="dropdown-item">Hosting</a>
            <a onClick={() => onProductSelect("ssl")} className="dropdown-item">SSL</a>
            <a onClick={() => onProductSelect("vps")} className="dropdown-item">VPS</a>
            <a onClick={() => onProductSelect("email")} className="dropdown-item">Email Server</a>
            <a onClick={() => onProductSelect("tadu_phone")} className="dropdown-item">Tổng Đài Ảo</a>
            <a onClick={() => onProductSelect("tadu_invoice")} className="dropdown-item">Hoá Đơn Điện Tử</a>
            <a onClick={() => onProductSelect("cloud_backup")} className="dropdown-item">Cloud Backup</a>
            <a onClick={() => onProductSelect("whois")} className="dropdown-item">Who Is Privacy</a>
            <a onClick={() => onProductSelect("ip")} className="dropdown-item">IP</a>
          </div>
        </div>
      </React.Fragment>
    )
}

class ProductSelect extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      domainStatic: null,
      vpsStatic: null,
      hostingStatic: null,
      emailStatic: null,
      sslStatic: null,
      taduPhoneStatic: null,
      taduInvoiceStatic: null,
      cloudBackupStatic: null,
    }
  }
  
  componentDidMount() {
    const self = this;
    const {service_status, is_product_config} = this.props;
    let status_key = service_status;
    if(service_status == "expired") {
      status_key = "suspend"
    }
    if(!is_product_config) {
      axios({
        method: 'get',
        url: window.api_url + '/admin/api/service/static/vps',
        withCredentials: true
      }).then(function (response) {
        self.setState({
          ...self.state,
          vpsStatic: response.data.data[status_key]
        })
      });
    
      axios({
        method: 'get',
        url: window.api_url + '/admin/api/service/static/domain',
        withCredentials: true
      }).then(function (response) {
        self.setState({
          ...self.state,
          domainStatic: response.data.data[status_key]
        })
      });
    
      axios({
        method: 'get',
        url: window.api_url + '/admin/api/service/static/email',
        withCredentials: true
      }).then(function (response) {
        self.setState({
          ...self.state,
          emailStatic: response.data.data[status_key]
        })
      });
    
      axios({
        method: 'get',
        url: window.api_url + '/admin/api/service/static/hosting',
        withCredentials: true
      }).then(function (response) {
        self.setState({
          ...self.state,
          hostingStatic: response.data.data[status_key]
        })
      });
    
      axios({
        method: 'get',
        url: window.api_url + '/admin/api/service/static/ssl',
        withCredentials: true
      }).then(function (response) {
        self.setState({
          ...self.state,
          sslStatic: response.data.data[status_key]
        })
      });
    
      axios({
        method: 'get',
        url: window.api_url + '/admin/api/service/static/taduphone',
        withCredentials: true
      }).then(function (response) {
        self.setState({
          ...self.state,
          taduPhoneStatic: response.data.data[status_key]
        })
      });
    
      axios({
        method: 'get',
        url: window.api_url + '/admin/api/service/static/tadu-invoice',
        withCredentials: true
      }).then(function (response) {
        self.setState({
          ...self.state,
          taduInvoiceStatic: response.data.data[status_key]
        })
      });
    
      axios({
        method: 'get',
        url: window.api_url + '/admin/api/service/static/cloud-backup',
        withCredentials: true
      }).then(function (response) {
        self.setState({
          ...self.state,
          cloudBackupStatic: response.data.data[status_key]
        })
      });
    }
  }


  render() {
    const {product_type_selected, onProductSelect, is_product_config} = this.props;
    const { domainStatic, vpsStatic, hostingStatic, emailStatic, sslStatic, taduPhoneStatic, taduInvoiceStatic, cloudBackupStatic } = this.state;
    return(
      <React.Fragment>
        {is_product_config ? DropboxButton(onProductSelect, product_type_selected) : 
        <LabelButton onProductSelect = {onProductSelect}
         domainStatic = {domainStatic}
         vpsStatic = {vpsStatic}
         hostingStatic = {hostingStatic}
         emailStatic = {emailStatic}
         sslStatic = {sslStatic}
         taduPhoneStatic = {taduPhoneStatic}
         taduInvoiceStatic = {taduInvoiceStatic}
         cloudBackupStatic = {cloudBackupStatic}
        />
       }
      </React.Fragment>
    )
  }

}


export default ProductSelect;